import { gql } from '../__generated__/gql'

export const ENTERPRISE_PLANS = gql(`
  query EnterprisePlans {
    enterprisePlans {
      count
      items {
        id
        orgName
        type
        planStartDate
        planExpirationDate
        inUseSeats
        maxSeats
        ssoConfigs {
          slug
          scope
          orgUrl
          domains
        }
        basicSetupDomains
        promoCodes
      }
    }
  }
`)

export const ENTERPRISE_PLAN_EXPIRATION_DATES = gql(`
  query EnterprisePlanExpirationDates {
    enterprisePlanExpirationDates {
      id
      orgName
      planExpirationDate
    }
  }
`)
